export const getBarColor = (status) => {
  switch (status) {
    case 'Poor':
      return '#FFF0E8'; // light-orange
    case 'Exceed':
      return '#D59572'; // dark-orange
    case 'Correct':
    default:
      return '#FF6414'; // orange-primary
  }
};


export const STATUS_COLOR_MAP = {
  Poor: '#FFF0E8',
  Correct: '#FF6414',
  Exceed: '#D59572'
};
